import Toastify from 'toastify-js';
const toasts = [];

const markInvalidCheckoutFields = () => {
    const invalidRows = document.querySelectorAll(
        '.woocommerce-checkout .form-row.woocommerce-invalid'
    );

    invalidRows.forEach(row => {
        const formField = row.querySelector('.form-field');

        if (formField) {
            formField.classList.add('error');
        }
    });
};

const woocommerceToast = (toasts = [], otherClass = false, error = false) => {
    let woocommerceNoticesWrapper = document.querySelector(
        '.woocommerce-notices-wrapper'
    );
    if (!woocommerceNoticesWrapper) return;
    if (otherClass)
        woocommerceNoticesWrapper = document.querySelector(
            '.woocommerce-NoticeGroup'
        );
    const clonedWoocommerceNoticesWrapper =
        woocommerceNoticesWrapper.cloneNode(true);
    const lists = woocommerceNoticesWrapper.querySelectorAll('ul');
    if (toasts.length > 0) {
        toasts.forEach(toast => {
            toast.toastElement.classList.add('d-none');
            toast.hideToast();
        });
    }
    if (lists.length === 0 && woocommerceNoticesWrapper.textContent) {
        const message = clonedWoocommerceNoticesWrapper.querySelector(
            '.woocommerce-message'
        );

        const info =
            clonedWoocommerceNoticesWrapper.querySelector('.woocommerce-info');

        let classType = 'success';

        if (error == true) {
            classType = 'error'
        } else {
            classType = 'success'
        };

        if (message) {
            toasts.push(
                Toastify({
                    node: message,
                    className: classType,
                    stopOnFocus: true,
                    duration: 5000,
                    close: true,
                    gravity: 'bottom',
                }).showToast()
            );
        }

        if (info) {
            toasts.push(
                Toastify({
                    node: info,
                    className: 'success',
                    stopOnFocus: true,
                    duration: 5000,
                    close: true,
                    gravity: 'bottom',
                }).showToast()
            );
        }
    } else {
        const isCartPage =
            document.body.classList.contains('woocommerce-cart') ||
            !!document.querySelector('.woocommerce-cart-form');

        lists.forEach(list => {
            const listClass = list.getAttribute('class');
            const status = listClass.substring(listClass.indexOf('-') + 1, 50);
            const listElements = list.querySelectorAll('li');

            listElements.forEach(element => {
                if (isCartPage) {
                    toasts.push(
                        Toastify({
                            node: element,
                            className: status,
                            stopOnFocus: true,
                            duration: 5000,
                            close: true,
                            gravity: 'bottom',
                        }).showToast()
                    );
                }

                const fieldId = element.getAttribute('data-id');

                if (fieldId) {
                    const formField = document.querySelector(
                        `[name=${fieldId}]`
                    );

                    if (formField) {
                        const formFieldParent =
                            formField.closest('.form-field');

                        if (formFieldParent) {
                            formFieldParent.classList.add('error');
                            const textWrapper =
                                formFieldParent.querySelector(
                                    '.js-text-wrapper'
                                );
                            textWrapper.textContent = element.textContent;
                        }
                    }
                }
            });
        });
    }
};

export const handleWoocommerceToasts = () => {
    $(document.body).on('updated_cart_totals', function () {
        woocommerceToast(toasts);
        // handleCouponField();
    });

    $(document.body).on('wc_cart_emptied', function () {
        woocommerceToast(toasts);
    });

    $(document.body).on('added_to_cart', function () {
        woocommerceToast([], false);
    });

    $(document.body).on('added_to_cart_error', function () {
        woocommerceToast([], false, true);
    });

    $(document.body).on('checkout_error', function (e) {
        woocommerceToast();
        if (document.querySelector('.woocommerce-NoticeGroup')) {
            woocommerceToast([], true);
        }
        markInvalidCheckoutFields();
    });

    const noticesWrapper = document.querySelector(
        '.woocommerce-notices-wrapper'
    );

    const observer = new MutationObserver(mutationsList => {
        // woocommerceToast();
    });

    const config = {
        childList: true,
        attributes: true,
        subtree: true,
    };

    if (noticesWrapper) {
        observer.observe(noticesWrapper, config);
    }
};
